import { vnModule_knockoutJS } from "../../../valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../../valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

import {vn_app_zone_notification} from "../../../valnet_jslib/vnApp/vn_app_zone_notification";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";
import {UploadStatusHandler} from "../../../../../js/utils/UploadStatusHandler";

import videoPicker_template from '../components/templates/videoPicker_template';

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;

export class videoPickerHelper {
    private videoPicker: videoPicker_template;
    private viewModel: any;
    private vnAppZone: any;
    private callerModule:any;
    protected getDataCallback: Function;
    protected getReferencesCallback: Function;
    protected progressBar: HTMLProgressElement;
    protected uploadProgress: any;
    protected isSaveGallery: any;
    private uploadStatus: UploadStatusHandler ;
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected galleryXHRHdl: XMLHttpRequestHandler;
    protected optimizableSections: Array<string>;

    protected videoXHRHdl: XMLHttpRequestHandler;
    protected referencesXHRHdl: XMLHttpRequestHandler;
    protected contentVideoXHRHdl: XMLHttpRequestHandler;
    private deleteVideoXHRHdl: XMLHttpRequestHandler;

    /**
     * Constructor for initializing video picker, view model, app zone, caller module, and optimizable sections.
     *
     * @param {any} videoPicker - the video picker object
     * @param {any} viewModel - the view model object
     * @param {any} vnAppZone - the app zone object
     * @param {any} callerModule - the caller module object
     * @param {Array<string>} optimizableSections - array of sections that can be optimized (default is an empty array)
     */
    constructor(videoPicker: any, viewModel: any, vnAppZone: any, callerModule:any, optimizableSections: Array<string> = []) {
        if (videoPicker != null) {
            this.videoPicker = videoPicker;
            this.videoPicker.setCaller(this);
        }
        this.viewModel = viewModel;
        this.vnAppZone = vnAppZone;
        this.callerModule = callerModule;
        this.uploadStatus = new UploadStatusHandler();
        this.optimizableSections = optimizableSections;
    }

    public clearThumbnailImage() {
        this.videoPicker.clearThumbnailImage();
    }

    public clearVideoFileInput() {
        this.videoPicker.clearVideoFileInput();
    }

    public resetPagination() {
        this.videoPicker.resetPagination();
    }

    public setDataCallback(getDataCallback: Function) {
        this.getDataCallback = getDataCallback;
    }

    public setOrientations(orientations) {
        this.videoPicker.setOrientations(orientations);
    }

    public setPermissions(permissions) {
        if (permissions) {
            this.videoPicker.setPermissions(permissions);
        }
    }

    public setRatios(ratios) {
        this.videoPicker.setRatios(ratios);
    }

    public setTarget(target) {
        this.videoPicker.setTarget(target);
    }

    public setThumbnailImage(image) {
        this.videoPicker.setThumbnailImage(image);
    }

    public setUploadIsInProgress(value: boolean) {
        this.videoPicker.setUploadIsInProgress(value);
    }

    public setUploadValue(value: number) {
        this.videoPicker.setUploadValue(value);
    }

    public setValidationMessage(messages) {
        this.videoPicker.setValidationMessage(messages);
    }

    public setValidationMessageOnAddVideo(messages) {
        this.videoPicker.setValidationMessageOnAddVideo(messages);
    }

    public setVideoCardElement(element) {
        this.videoPicker.setVideoCardElement(element);
    }

    public setVideoPagination(pagination) {
        this.videoPicker.setVideoPagination(pagination);
    }

    public setVideoPickerEditData(data, extra?) {
        this.videoPicker.setVideoPickerEditData(data, extra);
    }

    public setVideos(videos) {
        this.videoPicker.setVideos(videos);
    }

    public setViewVideoData(video) {
        this.videoPicker.setViewVideoData(video);
    }

    public showLoading() {
        this.videoPicker.showLoading();
    }

    public hideLoading() {
        this.videoPicker.hideLoading();
    }

    public showVideoPicker() {
        this.videoPicker.show();
    }

    public hideVideoPicker() {
        this.videoPicker.hide();
    }

    public showVideoPickerAdd() {
        this.videoPicker.showVideoPickerAdd();
    }

    public hideVideoPickerAdd() {
        this.videoPicker.hideVideoPickerAdd();
    }

    public showVideoPickerEdit() {
        this.videoPicker.showVideoPickerEdit();
    }

    public hideVideoPickerEdit() {
        this.videoPicker.hideVideoPickerEdit();
    }

    public showVideoPickerView() {
        this.videoPicker.showVideoPickerView();
    }

    public hideVideoPickerView() {
        this.videoPicker.hideVideoPickerView();
    }

    public showLoadingEditVideo() {
        this.videoPicker.showLoadingEditVideo();
    }

    public hideLoadingEditVideo() {
        this.videoPicker.hideLoadingEditVideo();
    }

    public getFileIsVideo() {
        return this.videoPicker.getFileIsVideo();
    }

    public getVideoIsNotUploadable() {
        return this.videoPicker.getVideoIsNotUploadable();
    }

    public getVideoPickerEditTemplate() {
        return this.videoPicker.videoPickerEdit;
    }

    public getVideoPickerTemplate() {
        return this.videoPicker;
    }

    public getVideoPickerTarget() {
        return this.videoPicker.getVideoPickerTarget();
    }

    public getViewModelForRequest() {
        return this.videoPicker.getViewModelForRequest();
    }

    public filterMultipleSelectorOnChange(idElement) {
        this.callerModule.filterMultipleSelectorOnChange(idElement);
    }

    protected filterSimpleOnChange(idElement) {
        this.callerModule.filterSimpleOnChange(idElement);
    }

    public getTagsSuggestion(keyword, idSourceElement){
        this.callerModule.getTagsSuggestion(keyword, idSourceElement);
    }

    public setTagsSuggestions(tags) {
        this.videoPicker.tagFilter.getTemplateViewModel().tags(tags);
    }

    public setEditTagsSuggestions(tags) {
        this.videoPicker.videoPickerEdit.filterTag.getTemplateViewModel().tags(tags);
    }

    public getVideosData(){
        if (this.videoXHRHdl) {
            this.videoXHRHdl.cancelAndReset();
        }

        this.showLoading();

        let idBrand = this.vnAppZone.app.params.idBrand;
        let url: string = '/api/brand/' + idBrand + '/videos/get/';
        let param: Array<Array<string>> = [];

        let viewModel = this.getViewModelForRequest();

        param.push(["data", ko.toJSON(viewModel)]);

        this.videoXHRHdl = new XMLHttpRequestHandler(url, param, this);
        this.videoXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.videoXHRHdl.onReadyStateFunction = this.onGetVideosDataReturn.bind(this);
        this.videoXHRHdl.execute();
    }

    protected onGetVideosDataReturn(req, obj){

        if (this.getDataCallback) {
            return this.getDataCallback;
        } else {
            if (this.callerModule && typeof this.callerModule.onGetVideosDataReturn === 'function') {
                return this.callerModule.onGetVideosDataReturn(req, obj);
            }
            if (obj.callerModule && typeof obj.callerModule.onGetVideosDataReturn === 'function') {
                return obj.callerModule.onGetVideosDataReturn(req, obj.callerModule);
            }

            // Default behaviour
            if (obj.callerModule && this.videoPicker) {
                return function (req, obj) {
                    obj.manageResponse(req, obj, function () {
                        let responseParsed = JSON.parse(req.request.response);

                        const {orientations, paginatedVideos, ratios} = responseParsed;
                        this.videoPicker.setVideoPagination(paginatedVideos);
                        this.videoPicker.setVideos(paginatedVideos.data);
                        if (ratios) {
                            this.videoPicker.setRatios(ratios);
                        }

                        if (orientations) {
                            this.videoPicker.setOrientations(orientations);
                        }
                        this.videoPicker.hideLoading();

                    }.bind(this));
                }.bind(this, req, obj.callerModule);
            }
        }
    }

    public editVideo(data) {
        this.videoPicker.editVideo(data);
    }

    public insertVideo(param?, target? , data?){
        if (this.callerModule && typeof this.callerModule.insertVideo === 'function') {
            this.callerModule.insertVideo(param, target, data);
        } else if (!this.callerModule) {
            throw "CallerModule not initialized. Ensure you have passed one to the constructor.";
        } else {
            throw "insertVideo not implemented. Please implement it in the caller module.";
        }
    }

    public saveVideo(videoData, param?) {
        if (this.callerModule && typeof this.callerModule.saveVideo === 'function') {
            this.callerModule.saveVideo(videoData, param);
        } else if (!this.callerModule) {
            throw "CallerModule not initialized. Ensure you have passed one to the constructor.";
        } else {
            throw "saveVideo not implemented. Please implement it in the caller module.";
        }
    }

    public handleSaveVideo(videoData, param?){
        this.showLoadingEditVideo();
        let idBrand = this.vnAppZone.app.params.idBrand;
        let url: string = `/api/brand/${idBrand}/videos/save/`;
        let params: Array<Array<string>> = [];

        videoData['idProducer'] = this.getVideoPickerEditTemplate().getTemplateViewModel().filterUser_producer.idUser();
        videoData['videoTags'] = this.getVideoPickerEditTemplate().getTemplateViewModel().selectedTags();
        videoData['idPrimaryTag'] = this.getVideoPickerEditTemplate().getTemplateViewModel().idPrimaryTag();
        videoData['videoCategories'] = this.getVideoPickerEditTemplate().getTemplateViewModel().selectedCategories();
        videoData['idPrimaryCategory'] = this.getVideoPickerEditTemplate().getTemplateViewModel().idPrimaryCategory();
        videoData['idContentType'] = this.getVideoPickerEditTemplate().getTemplateViewModel().idContentType();
        videoData['videoSubtitles'] = this.getVideoPickerEditTemplate().getTemplateViewModel().subtitlesFiles();

        params.push(["data", ko.toJSON(videoData)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(url, params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {
                if (req.request.readyState == 4) {
                    obj.hideLoadingEditVideo();
                    if (req.request.status == 200) {
                        obj.getVideoPickerEditTemplate().validations.clearMessages();
                        obj.callerModule.manageResponse(req, obj, function () {
                            let responseParsed = JSON.parse(req.request.response);
                            let video = responseParsed.video;
                            obj.hideVideoPickerEdit();
                            const target = obj.getVideoPickerTarget()
                            if(param == "insert-save"){
                                obj.insertVideo(param, target, video)
                            }
                            if(target == "featured_video" && param =="save"){
                                obj.insertVideo(param, target, video)
                                obj.hideVideoPickerEdit()
                                obj.callerModule.setFeaturedVideo(video)
                            }
                            //refresh video view data
                            obj.setViewVideoData(video)
                            obj.getVideosData();
                        })
                    } else if (req.request.status == 400) {
                        let errorResponse = JSON.parse(req.request.response);
                        const { validations } = errorResponse
                        obj.getVideoPickerEditTemplate().setValidationMessage(validations);
                    } else {
                        const messages = [{ field: "Video", label:"Video Save Error", messages: ["An error has occured"] }]
                        obj.getVideoPickerEditTemplate().setValidationMessage(messages)
                    }
                }
            }
        });
        XHRHdl.execute();
    }

    public handleVideoUpload(files){

        if(this.getVideoIsNotUploadable() && this.getFileIsVideo()){

            //const messages =[{ field: "Video", label:"Size limit exceeded", messages: ["Video uploads cannot exceed 150MB per minute of video."] }]
            //this.editForm.videoPicker.setValidationMessageOnAddVideo(messages)
            this.clearVideoFileInput()
            return;
        }

        let idBrand = this.vnAppZone.app.params.idBrand;
        let url: string = `/api/brand/${idBrand}/videos/upload/`;

        const formData = new FormData()
        for (const file of files) {
            formData.append('videos[]', file)
        }


        const uploadPromise = new Promise((resolve, reject) => {

            let xhr = new XMLHttpRequest()
            xhr.responseType = 'json'

            xhr.open("POST", url)

            xhr.onload = () => {
                const response = xhr.response
                if(xhr.readyState  === 4 && xhr.status === 200) resolve(response)
                else reject(response)
            }

            xhr.upload.onprogress = (ev) => {
                console.log("Progress")
                const percentComplete = Math.round((ev.loaded / ev.total) * 100);
                this.setUploadValue(percentComplete)

            }

            xhr.upload.onloadstart = () => {
                console.log("Upload started")
                this.setUploadIsInProgress(true)

            }
            xhr.upload.onloadend = () => {
                console.log("Upload finished")
                this.setUploadIsInProgress(false)
            }

            xhr.send(formData)
        })

        uploadPromise
            //If success
            .then(response => {
                //response['uploadVideos'][0]['details'] = null;
                //response['uploadVideos'][0]['id'] = 0;
                this.hideVideoPickerAdd();
                this.clearVideoFileInput();
                this.setVideoPickerEditData(response['uploadVideos'][0]);
                this.showVideoPickerEdit();
                this.setUploadValue(0);
            }).catch( errorResponse => {
                if(errorResponse){
                    const {type, validations} = errorResponse;
                    if(type == "validation") {
                        this.setValidationMessageOnAddVideo(validations);
                        this.clearVideoFileInput();
                        this.setUploadValue(0);
                    }
                }else{
                    const messages =[{ field: "Video", label:"Upload Error", messages: ["Video file cannot be uploaded!"] }];
                    this.setValidationMessageOnAddVideo(messages);
                    this.clearVideoFileInput();
                    this.setUploadValue(0);
                }

            })
    }

    public getVideoReferences() {
        if (this.referencesXHRHdl) {
            this.referencesXHRHdl.cancelAndReset();
        }

        this.showLoading();

        let idBrand = this.vnAppZone.app.params.idBrand;
        let url: string = `/api/brand/${idBrand}/videos/references/`;
        let param: Array<Array<string>> = [];

        let viewModel = this.getViewModelForRequest();

        param.push(["data", ko.toJSON(viewModel)]);

        this.referencesXHRHdl = new XMLHttpRequestHandler(url, param, this);
        this.referencesXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.referencesXHRHdl.onReadyStateFunction = this.onGetVideoReferencesReturn.bind(this);
        this.referencesXHRHdl.execute();
    }

    protected onGetVideoReferencesReturn(req, obj) {
        if (this.getReferencesCallback) {
            return this.getReferencesCallback;
        } else {
            if (this.callerModule && typeof this.callerModule.onGetVideoReferencesReturn === 'function') {
                return this.callerModule.onGetVideoReferencesReturn(req, obj);
            }
            if (obj.callerModule && typeof obj.callerModule.onGetVideoReferencesReturn === 'function') {
                return obj.callerModule.onGetVideoReferencesReturn(req, obj.callerModule);
            }

            // Default behaviour
            if (obj.callerModule && this.videoPicker) {
                return function (req, obj) {
                    obj.manageResponse(req, obj, function () {
                        let responseParsed = JSON.parse(req.request.response);
                        this.videoPicker.setContentTypeFilter(responseParsed.contentTypes);
                        this.videoPicker.setCategoryFilter(responseParsed.categories);
                        let contentTypeNames  = ["Trailer","Guide","Feature","News","List","Interview","Podcast","Review"];
                        let filteredContentTypes = [];
                        let videoPickerContentTypes = [...responseParsed.contentTypes];
                        for(let i=0;i<contentTypeNames.length;i++){
                            let contentType = contentTypeNames[i];
                            let option = videoPickerContentTypes.find(x => x.name == contentType);
                            if(option){
                                filteredContentTypes.push(option);
                            }
                        }
                        this.getVideoPickerEditTemplate().setContentTypes(filteredContentTypes);
                        this.getVideoPickerEditTemplate().setCategories(responseParsed.categories);
                        this.getVideoPickerEditTemplate().setSubtitlesLanguages(responseParsed.languages);
                    }.bind(this));
                }.bind(this, req, obj.callerModule);
            }
        }
    }

    public setContentTypeFilter(contentTypes) {
        this.videoPicker.setContentTypeFilter(contentTypes);
    }

    public setCategoryFilter(categories) {
        this.videoPicker.setCategoryFilter(categories);
    }

    public getUploadUrlSubtitles(): string {
        return `/api/brand/${this.vnAppZone.app.params.idBrand}/videos/subtitles/upload`;
    }
}


// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/modules/videoPickerHelper.ts